import { useMemo } from 'react'

import { faBug } from '@document-crunch/pro-regular-svg-icons'

import { Icon, IconColor } from '@dc-shared-web/components/base'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dc-shared-web/components/shadcn'
import { useAuth } from '@dc-shared-web/providers'
import { useChat } from '@dc-shared-web/providers/ChatProvider'
import { ChatServiceState } from '@dc-shared-web/providers/ChatProvider/types'

const DebugMenu = () => {
  const { user } = useAuth()
  const {
    users: chatUsers,
    currentUserId,
    switchUser,
    setServiceStatus,
    setErrorState,
    clearDebugState,
    toggleWorking,
  } = useChat()

  const enabled = useMemo(() => user && user.is_super_admin, [user])

  const availableUsers = useMemo(() => {
    if (!user) {
      return []
    }

    if (chatUsers.length === 0) {
      return [
        {
          id: user.id,
          name: user.name,
        },
      ]
    }
    // Ensure the current user is always at the top of the list
    return [
      {
        id: user.id,
        name: user.name,
      },
      ...chatUsers.filter((chatUser) => chatUser.id !== user.id),
    ]
  }, [chatUsers, user])

  return enabled ? (
    <div className='tw-flex tw-justify-between tw-py-2 tw-pr-3'>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant='icon'
            className='tw-h-[26px] tw-w-[26px] tw-p-0 tw-ml-2'
          >
            <Icon icon={faBug} color={IconColor.muted} size='sm' />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent sideOffset={-2} className='tw-z-[100]'>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={() => setServiceStatus(ChatServiceState.BUSY)}
          >
            Set busy
          </DropdownMenuItem>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={() => setServiceStatus(ChatServiceState.UNAVAILABLE)}
          >
            Set unavailable
          </DropdownMenuItem>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={setErrorState}
          >
            Set error state
          </DropdownMenuItem>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={clearDebugState}
          >
            Clear
          </DropdownMenuItem>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={() => toggleWorking(true)}
          >
            Show Working Indicator
          </DropdownMenuItem>
          <DropdownMenuItem
            className='tw-cursor-pointer'
            onClick={() => toggleWorking(false)}
          >
            Hide Working Indicator
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Select
        value={currentUserId?.toString()}
        onValueChange={(id) => switchUser(parseInt(id, 10))}
      >
        <SelectTrigger className='tw-w-[200px] tw-h-[26px]'>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className='tw-z-[51]'>
          <SelectGroup>
            {availableUsers.map((user) => (
              <SelectItem key={user.id} value={user.id.toString()}>
                {user.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  ) : null
}

export default DebugMenu
